export function isEmailConfirmationRequired(
  requireEmailConfirmation?: boolean,
  isEmailConfirmed?: boolean
) {
  return requireEmailConfirmation === true && isEmailConfirmed === false
}
